export default __webpack_public_path__ + "static/media/arrow.43e2b2cd.svg";